
	export default { name: 'VFieldGroup' } // name the component
